import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import { Jumbotron } from "./migration";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";
// const gitHubQuery = "/repos?sort=updated&direction=desc";
// const specficQuerry = "https://api.github.com/repos/hashirshoaeb/";

const Project = ({ heading, username, length, specfic }) => {
  // const allReposAPI = `${API}/users/${username}/repos?sort=updated&direction=desc`;
  // const specficReposAPI = `${API}/repos/${username}`;
  const dummyProjectsArr = new Array(length + specfic.length).fill(
    dummyProject
  );

  // const [projectsArray, setProjectsArray] = useState([]);

  // const fetchRepos = useCallback(async () => {
  //   let repoList = [];
  //   try {
  //     // getting all repos
  //     const response = await axios.get(allReposAPI);
  //     // slicing to the length
  //     repoList = [...response.data.slice(0, length)];
  //     // adding specified repos
  //     try {
  //       for (let repoName of specfic) {
  //         const response = await axios.get(`${specficReposAPI}/${repoName}`);
  //         repoList.push(response.data);
  //       }
  //     } catch (error) {
  //       console.error(error.message);
  //     }
  //     // setting projectArray
  //     // TODO: remove the duplication.
  //     setProjectsArray(repoList);
  //   } catch (error) {
  //     console.error(error.message);
  //   }
  // }, [allReposAPI, length, specfic, specficReposAPI]);

  // useEffect(() => {
  //   fetchRepos();
  // }, [fetchRepos]);

  const projectsArray = [
    {
      name: 'Cybersecurity AI Meeting Assistant: sponsored by Rule4 Inc',
      description: "Led a team of five to architect and implement a GenAI-based meeting assistant leveraging advanced cloud technologies. Utilizing Azure and OpenStack platforms, we integrated the LLM model Llama 2, optimized with CUDA programming, as the core processing unit. The solution involved using Azure Blob Storage for scalable and secure storage of meeting recordings and transcripts, and Azure Key Vault for managing sensitive information such as API keys and access credentials securely. Azure Functions were leveraged to handle event-driven processes, enabling efficient and cost-effective execution of backend services. A Slack bot, integrated using the Slack API, facilitated seamless communication by delivering meeting summaries, key discussion topics, and actionable items directly to users' channels. The assistant autonomously processes meeting data to extract relevant information and generate concise summaries, leveraging the natural language processing capabilities of Llama 2. This includes identifying key topics and action items, thereby enhancing team productivity and ensuring critical points are not overlooked. The implementation demonstrates proficiency in cloud computing, machine learning, and AI-driven automation, underscoring technical leadership and expertise in deploying sophisticated AI solutions in a cybersecurity context.",
      svn_url: 'https://drive.google.com/file/d/1G0IHz0pF6ZRIMFMmQ_e9G7LEMt_Vs-fx/view?usp=sharing',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'January 2024',
    },
    {
      name: 'ExpenseLens: A smart expense management system',
      description: "I collaborated with a team of two to develop ExpenseLens, an intelligent expense management system aimed at automating expenditure tracking through OCR technology and intelligent categorization. The backend, powered by a Flask application, incorporated OCR for efficient image processing and employed microservices architecture for modularity. The system utilized Redis for temporary data storage, Cloud SQL for PostgreSQL for persistent storage, and Google Cloud Storage Bucket for storing receipt images. Docker and Kubernetes were implemented for containerization and orchestration, ensuring scalability and resilience. ",
      svn_url: 'https://github.com/Rishiii7/ExpenseLens',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'Dec 14 2023',
    },
    {
      name: 'Hearing the unheard, seeing the unseen: Automated sign language recognition for emergency situations',
      description: "Proposed an innovative solution to address communication challenges faced by the deaf-mute community in emergency contexts through an automated system recognizing dynamic hand gestures in Indian Sign Language (ISL). The system classifies ISL gestures into eight crucial emergency words and includes real-time monitoring using CCTV cameras. The core utilizes a Vision Transformer (ViT) encoder for feature extraction and a Bidirectional Long Short-Term Memory (BiLSTM) model for sequence classification. Achieved a remarkable 96% accuracy, outperforming previous models. Developed in Python, leveraging HuggingFace, Tensorflow, and Keras for model development, along with Pandas, OpenCV, and Katna for efficient video data processing.",
      svn_url: 'https://github.com/Mprach18/Automated-sign-language-recognition-for-emergency-situations',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'Feb 10 2023',
    },
    {
      name: 'Legal Named Entities Extraction (L-NER), SemEval 2022',
      description: "Addressing the complexity of Indian legal documents, our project focuses on Named Entity Recognition (NER) using a transformer-based solution. Initially, we employed a BERT-based transformer and LSTM-based sequence classification, but limitations led us to a revised approach. Leveraging pre-trained BERT, we encoded and decoded token-level input sequences for tag-labeled sequences. Our exploration included IOBE tagging for span-level entity categorization. Implemented with Python libraries like HuggingFace, Keras, TensorFlow, SimpleTransformers, SpaCy, and Pandas, our solution offers an efficient tool for Legal Named Entity Recognition (L-NER), aiding the legal industry in extracting crucial information accurately and efficiently.",
      svn_url: 'https://github.com/Mprach18/Legal-Named-Entities-Extraction-L-NER-using-Transformers',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'Mar 06 2023',
    },
    {
      name: 'Soundscape: A song recommender system',
      description: "Collaborated in a six-member team to develop a web app utilizing Spotify's Million Song Dataset. My pivotal role involved crafting the backend's core engine using Pyspark on Google Cloud Platform's Dataproc. Implemented algorithms for cosine similarity scores, enhancing song relationships. Introduced genre-level partitioning for more accurate playlist recommendations. Used ReactJS for the frontend, seamlessly integrated with Flask APIs.",
      svn_url: 'https://github.com/Mprach18/Big-Data-Architecture-Project',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'Apr 25 2023',
    },
    {
      name: 'TACE: Tracking Airplane Carbon Emissions',
      description: "Developed an application to track city-level carbon emissions associated with air travel, promoting awareness and sustainable transportation choices. Utilized OpenFlight for detailed flight data and World Cities population data to enrich correlations. Employed Apache Spark for data processing, stored in PostgresDB, and a React-based web interface on a GKE cluster for user interactions. Implemented a machine learning-based prediction engine correlating city population with aviation CO2 emissions, revealing a linear relationship with exceptions for tourist cities and multiple airports within a single city.",
      svn_url: 'https://github.com/callingmedic911/tace',
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'May 06 2023',
    },
    {
      name: 'Microsoft Azure-based IoT monitoring platform  (sponsored by Espressif Systems India Pvt. Ltd.)',
      description: "I worked with a dynamic team of five members on the development of a cutting-edge cloud-native application aimed at facilitating user onboarding and remote control of IoT devices. Our project was driven by the vision of enhancing user accessibility and control in the IoT ecosystem. As part of our development process, we meticulously crafted a prototype to conduct a comparative analysis of hosting options. This involved deploying the application on both Amazon Web Services (AWS) Elastic Compute Cloud (EC2) and Microsoft Azure Virtual Machine (VM) services. Through this comparative analysis, we sought to identify the most efficient and cost-effective hosting solution for our cloud-native application. To optimize the application's performance and enhance cost-efficiency, we implemented a strategic integration of Azure services. Specifically, we incorporated the Azure Function App and leveraged the capabilities of Azure API Management service. This integration not only streamlined the application's performance but also led to a substantial reduction in infrastructure costs, slashing expenses by an impressive 30%. In our development journey, we utilized an array of tools and programming languages to bring our vision to life. These included the ESP32 microcontroller, which played a central role in IoT device communication, the Mosquitto MQTT broker for efficient message exchange, Python for backend development, Paho MQTT for MQTT protocol support, Azure CosmosDB for data management, and Angular 8 for building a responsive and user-friendly frontend. In summary, our collaborative effort resulted in the creation of a cloud-native application that empowers users to seamlessly onboard and remotely manage their IoT devices. Through our strategic analysis and integration of Azure services, we not only optimized performance but also delivered substantial cost savings. This project showcases the intersection of IoT innovation and cloud-native architecture, providing users with enhanced control over their IoT ecosystem.",
      svn_url: null,
      stargazers_count: null,
      languages_url: null,
      pushed_at: 'Apr 30 2020',
    }
    
  ]

  console.log(projectsArray)

  return (
    <Jumbotron fluid id="projects" className="bg-light m-0">
      <Container className="">
        <h2 className="display-4 pb-5 text-center">{heading}</h2>
        <Row>
          {projectsArray.length
            ? projectsArray.map((project, index) => (
              <ProjectCard
                key={`project-card-${index}`}
                id={`project-card-${index}`}
                value={project}
              />
            ))
            : dummyProjectsArr.map((project, index) => (
              <ProjectCard
                key={`dummy-${index}`}
                id={`dummy-${index}`}
                value={project}
              />
            ))}
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Project;
